function compose(...fns) {
  return (x0) => fns.reduce((x, f) => f(x), x0);
}

function deepConcat(items, separator = " ") {
  const itemTypes = [...new Set(items.map((item) => typeof item))].filter((type) => type !== "undefined");
  if (itemTypes.length > 1)
    throw new Error("All items must be of the same type");
  if (items.length === 0)
    return "";
  if (itemTypes[0] === "string")
    return items.filter((item) => item !== void 0).join(separator).trim();
  if (itemTypes[0] === "object") {
    const itemKeys = [...new Set(items.filter((item) => item !== void 0).flatMap((item) => Object.keys(item)))];
    const result = {};
    itemKeys.forEach((key) => {
      result[key] = deepConcat(items.filter((item) => item !== void 0).map((item) => item[key]), separator);
    });
    return result;
  }
}

function escapeRegex(string) {
  return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}

export { compose as c, deepConcat as d, escapeRegex as e };
//# sourceMappingURL=escapeRegex-Bu1SqOvG.js.map
